import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import ActionBar from '../../common/ActionBar';
import ContactHelpText from '../../common/ContactHelpText';
import { updateStep } from '../../../slices/booking';
import { BACK, NEXT, STEP_ORDERS } from '../../../constants/bookingConstants';
import { ROUTE_PREFIX_BOOKING } from '../../../constants/routes';
import { generateNextStep } from '../../../utils/bookingUtils';

const BookingActionBar = ({
  amountLabel,
  amount,
  nextLabel,
  onNext,
  isNextDisabled,
  isLoading,
}) => {
  const { step } = useSelector(({ booking }) => booking);
  const dispatch = useDispatch();
  const history = useHistory();
  const { workflowId } = useParams();

  const isLastStep = STEP_ORDERS.indexOf(step) === STEP_ORDERS.length - 1;

  const goToStep = (newStep, newRoute) => {
    dispatch(updateStep(newStep));
    history.push(`${ROUTE_PREFIX_BOOKING}/${workflowId}${newRoute}`);
  };

  const handleBack = () => {
    const { newStep, newRoute } = generateNextStep(BACK, step);

    if (!newStep) {
      history.push(`${ROUTE_PREFIX_BOOKING}/${workflowId}`);
      return;
    }

    goToStep(newStep, newRoute);
  };

  const handleNext = async () => {
    const isJumpingToNextStep = onNext ? await onNext() : true;

    if (!isJumpingToNextStep) return;

    const { newStep, newRoute } = generateNextStep(NEXT, step);

    if (newStep) {
      goToStep(newStep, newRoute);
    }
  };

  return (
    <>
      <ContactHelpText />

      <ActionBar
        amountLabel={amountLabel}
        amount={amount}
        currency={amount ? 'AUD' : undefined}
        onBack={handleBack}
        nextLabel={nextLabel || (isLastStep ? 'Confirm' : 'Next')}
        onNext={handleNext}
        isNextDisabled={isNextDisabled}
        isLoading={isLoading}
      />
    </>
  );
};

export default BookingActionBar;
